import { render, staticRenderFns } from "./SupportTag.vue?vue&type=template&id=74a8c9de&scoped=true&"
import script from "./SupportTag.vue?vue&type=script&lang=js&"
export * from "./SupportTag.vue?vue&type=script&lang=js&"
import style0 from "./SupportTag.vue?vue&type=style&index=0&id=74a8c9de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a8c9de",
  null
  
)

export default component.exports